$(document).ready(function () {

    var widgetsCreated = false;
    var sectionIdFounded = false;
    var sectionID = "";

    var sectionIdCheckingInterval = setInterval(function () {
        if (document.querySelector("span.balance-section-id")) {
            sectionID = document.querySelector("span.balance-section-id").id;
            sectionIdFounded = true;
            console.log("sectionID: " + sectionID);
            clearInterval(sectionIdCheckingInterval);
        }
    }, 1000);

    var divCheckingInterval = setInterval(function () {
        // Find it with a selector
        console.log("run!");

        if (sectionIdFounded) {
            const config = {
                productId: 5783955079331, // Required
                injectionParent: '#product-form-template--' + sectionID + '__balance-time2', // The node that will have the widget injected in
                injectionMethod: 'prepend', // How will the widget be injected 
                injectFn: (node, target) => { }, // Runs a custom injection function 
                selectors: {
                    price: ['.my-price-selector'], // the selectors that will be updated based on subscription
                    variant: ['.product-form-template--' + sectionID + '__balance-time2-input'] // The variants to watch for to update the subscription prices
                }
            };

            const config2 = {
                productId: 5742267531427, // Required
                injectionParent: '#product-form-template--' + sectionID + '__balance-time1', // The node that will have the widget injected in
                injectionMethod: 'prepend', // How will the widget be injected 
                injectFn: (node, target) => { }, // Runs a custom injection function 
                selectors: {
                    price: ['.my-price-selector'], // the selectors that will be updated based on subscription
                    variant: ['.product-form-template--' + sectionID + '__balance-time1-input'] // The variants to watch for to update the subscription prices
                }
            };

            const config3 = {
                productId: 6100372455587, // Required
                injectionParent: '#product-form-template--' + sectionID + '__balance-time3', // The node that will have the widget injected in
                injectionMethod: 'prepend', // How will the widget be injected 
                injectFn: (node, target) => { }, // Runs a custom injection function 
                selectors: {
                    price: ['.my-price-selector'], // the selectors that will be updated based on subscription
                    variant: ['.product-form-template--' + sectionID + '__balance-time3-input'] // The variants to watch for to update the subscription prices
                }
            };

            const config4 = {
                productId: 6089948332195, // Required
                injectionParent: '#product-form-template--' + sectionID + '__balance-time4', // The node that will have the widget injected in
                injectionMethod: 'prepend', // How will the widget be injected 
                injectFn: (node, target) => { }, // Runs a custom injection function 
                selectors: {
                    price: ['.my-price-selector'], // the selectors that will be updated based on subscription
                    variant: ['.product-form-template--' + sectionID + '__balance-time4-input'] // The variants to watch for to update the subscription prices
                }
            };

            const config5 = {
                productId: 8031757533347, // Required
                injectionParent: '#product-form-template--' + sectionID + '__balance-time5', // The node that will have the widget injected in
                injectionMethod: 'prepend', // How will the widget be injected 
                injectFn: (node, target) => { }, // Runs a custom injection function 
                selectors: {
                    price: ['.my-price-selector'], // the selectors that will be updated based on subscription
                    variant: ['.product-form-template--' + sectionID + '__balance-time5-input'] // The variants to watch for to update the subscription prices
                }
            };

            const configs = [config, config2, config3, config4, config5];

            if (!widgetsCreated) {
                window.ReChargeWidget.createWidget(config);
                window.ReChargeWidget.createWidget(config2);
                window.ReChargeWidget.createWidget(config3);
                window.ReChargeWidget.createWidget(config4);
                window.ReChargeWidget.createWidget(config5);

                widgetsCreated = true;
            }

            if (document.querySelector(".rc-template")) {
                console.log("Found!");
                clearInterval(divCheckingInterval);
                // Do something
                console.log("end!");
            }
        }
    }, 1000);
});